import React, { useState } from "react";
import styled from "styled-components";
import Footer from "./Footer";
import BookingButton from "./BookingButton";
import Navbar from "./Navbar";
import DesktopMenu from "./DesktopMenu";
import img from "../images/spin.gif";
// import Slideshow from './Slideshow';

const Hypnotherapy = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (section) => {
    setOpenSections((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };

  return (
    <>
      <Navbar />
      <DeskWrap>
        <DesktopMenu />
        <Wrapper>
          <Body>
            <h1>1:1 Hypnotherapy</h1>
            <h3>Book an appointment</h3>
          </Body>
          <BookWrap>
            <SessionOptions>
              <SessionOption>
                <SessionLabel>Online session</SessionLabel>
                <BookingButtonWrap>
                  <BookingButton />
                </BookingButtonWrap>
              </SessionOption>
              <SessionOption>
                <SessionLabel>In-person session, Brussels</SessionLabel>
                <BuyButton
                  href="https://www.lokahistudio.com/therapies-holistiques"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book now
                </BuyButton>
              </SessionOption>
            </SessionOptions>
            <Img src={img} />
          </BookWrap>
          <Body>
            <p>
              90 minute 1:1 hypnotherapy sessions can take place virtually or in
              person at LOKAHI studio in Saint-Gilles, Brussels.{" "}
            </p>
            <p>
              The session includes a consultation and the hypnotic experience
              lasts between 45 and 60 minutes.{" "}
            </p>
            <p>
              Following the hypnosis we take some time to integrate and discuss
              the experience. After the session clients generally feel wonderful
              and prepared to move on with their day or go home to bed if they
              wish.{" "}
            </p>

            <RateGrid>
              <RateCard>
                <RateName>Single Session</RateName>
                <RatePrice>€150</RatePrice>
                <RateDesc>
                  One session, tailored to what you're working with right now.
                </RateDesc>
              </RateCard>

              <RateCard>
                <RateName>3-Session Package</RateName>
                <RatePrice>€375</RatePrice>
                <RateDesc>
                  For sustained work on something specific.
                </RateDesc>
              </RateCard>

              <RateCard>
                <RateName>5-Session Package</RateName>
                <RatePrice>€550</RatePrice>
                <RateDesc>
                  The deepest 1:1 arc, for changing something that's been
                  resistant to change.
                </RateDesc>
              </RateCard>

              <RateCard>
                <RateName>Six-Month Container</RateName>
                <RatePrice>€2000</RatePrice>
                <RateDesc>
                  My most complete way of working together: up to three 1:1
                  sessions a month, ongoing support via email/text, plus full
                  access to every workshop, ritual, and recording I've released.
                  Built for sustained change, not a single fix.
                </RateDesc>
              </RateCard>
            </RateGrid>
          </Body>

          <Body>
            <h2>FAQ</h2>
            <SectionToggle onClick={() => toggleSection("faq")}>
              What should I expect from the hypnotic experience?
            </SectionToggle>
            <Drop isOpen={openSections.faq}>
              <p>
                During a hypnotherapy session, you can expect to enter a state
                of deep relaxation where your mind becomes highly focused and
                receptive to positive suggestions. Contrary to popular myths,
                you will remain fully aware and in control throughout the
                session. The experience often involves guided visualizations,
                calming imagery, and verbal cues that help you access your
                subconscious mind. Many people describe the sensation as deeply
                relaxing, similar to daydreaming or meditation. The goal is to
                create a state where you can effectively address and transform
                specific behaviors, thoughts, or emotions.
              </p>
            </Drop>

            <SectionToggle onClick={() => toggleSection("issues")}>
              What issues does hypnotherapy work for?
            </SectionToggle>
            <Drop isOpen={openSections.issues}>
              <p>
                Hypnotherapy tends to work well anywhere a habit, a fear, or a
                pattern has stopped responding to reasoning alone: the smoking
                or drinking you've tried to quit through sheer willpower, sleep
                that won't come no matter how tired you are, performance anxiety
                that shows up right when you need steadiness most, or a
                low-grade stress that's become background noise. It's also
                useful for building confidence and working through specific
                phobias.
              </p>
              <p>
                What it isn't: a substitute for therapy. If you're working
                through significant trauma, hypnotherapy can be a valuable
                complement to that work, but it isn't a replacement for a
                licensed therapist, and I'll always say so directly if that's
                what would actually serve you.
              </p>
            </Drop>

            <SectionToggle onClick={() => toggleSection("virtual")}>
              Does virtual hypnosis work?
            </SectionToggle>
            <Drop isOpen={openSections.virtual}>
              <p>
                Yes. Virtual hypnosis offers the same core benefits as an
                in-person session — the guided relaxation, visualization, and
                suggestion all carry over through a video call. Many clients
                find the virtual format just as effective, and more workable for
                a busy or geographically scattered life.
              </p>
            </Drop>
          </Body>
          {/* <Slideshow/> */}
        </Wrapper>
      </DeskWrap>
      <Footer />
    </>
  );
};

const Img = styled.img`
  max-width: 100px;
  margin-left: 1rem;

  @media (min-width: 500px) {
    max-width: 130px;
    margin-left: 1.5rem;
  }

  @media (min-width: 1000px) {
    margin-top: 0;
  }
`;

const DeskWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;

  @media (min-width: 1000px) {
    flex-direction: row;
  }
`;
const Body = styled.div`
  font-family: var(--font-body);
  margin-top: 3%;
  width: 95%;
  padding: 0 1rem;
  max-width: 100%;

  h1 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    color: #333;
  }

  h2 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #333;
  }

  h3 {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    color: #333;
  }

  p {
    line-height: 1.6;
    margin-bottom: 1.2rem;
    color: #444;
  }

  @media (min-width: 1000px) {
    margin-top: 0%;
    margin-right: 2rem;
    max-width: 50%;
    padding: 0 1rem;
  }
`;

const Drop = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? "1000px" : "0")};
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
  overflow: hidden;
  transition:
    max-height 0.6s ease,
    opacity 0.6s ease;
  margin: ${({ isOpen }) => (isOpen ? "1rem 0" : "0")};
  padding: ${({ isOpen }) => (isOpen ? "0 1rem" : "0")};

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin: 1rem 0;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
`;

const SectionToggle = styled.h3`
  font-size: 1rem;
  cursor: pointer;
  margin: 1rem 0;
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
  transition: all 0.3s ease;

  &:hover {
    color: rgba(255, 119, 200, 0.18);
    padding-left: 0.5rem;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 90vh;
  width: 90%;
  max-width: 100%;
  padding: 1rem 0;
  overflow-x: hidden;

  @media (min-width: 1000px) {
    padding: 2rem 0;
  }
`;

const BookWrap = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  margin: 1.5rem 0;
  padding: 0 1rem;
  overflow-x: hidden;

  @media (min-width: 1000px) {
    padding: 0 1rem;
  }
`;

const SessionOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
`;

const SessionOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SessionLabel = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
`;

const BuyButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 105px;
  height: 42px;
  padding: 0 1rem;
  text-align: center;
  background: black;
  color: #f6f4ef !important;
  text-decoration: none;
  border-radius: 0.4rem;
  font-weight: 600;
  transition: background 0.2s ease;
  font-size: small;

  &:hover {
    background: #000;
  }
`;

const BookingButtonWrap = styled.div`
  /* width: 200px;
    height: 48px;

    a, div {
        width: 100%;
        height: 100%;
    }

    a {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    } */
`;

const RateGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin: 1.5rem 0;

  @media (min-width: 700px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const RateCard = styled.div`
  border: 1px solid ${({ $featured }) => ($featured ? "#333" : "#eee")};
  border-radius: 0.5rem;
  padding: 1.25rem;
  background: ${({ $featured }) =>
    $featured ? "rgba(0,0,0,0.03)" : "transparent"};
`;

const RateName = styled.p`
  font-weight: 600;
  color: #333;
  margin: 0 0 0.25rem;
`;

const RatePrice = styled.p`
  font-size: 1.4rem;
  color: #333;
  margin: 0 0 0.5rem;
`;

const RateDesc = styled.p`
  font-size: 0.9rem;
  line-height: 1.6;
  color: #444;
  margin: 0;
`;

export default Hypnotherapy;
